<template>
  <div>error</div>
</template>
<script>
export default {
  name: 'AppErrorComponent',
};
</script>
